// extracted by mini-css-extract-plugin
export default {"pellet":"PelletCard_pellet__g5EBZ","startIcon":"PelletCard_startIcon__YEmuJ"};